<template>
  <div>
    <div class="page-title">New Video</div>
    <Notice type="info" title="Environment Agnostic">
      This video will be shared across staging and production — no
      deployment needed.
    </Notice>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Video" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.videos.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Video",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
    this.$store.commit("ui/setEnvAgnostic", true);
  },
  beforeDestroy() {
    this.$store.commit("ui/setEnvAgnostic", false);
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Video.new();
      this.form = { data: { ctas: [] }, ...data };
    },
    async create() {
      await this.$api.Video.create(this.form);
      this.$router.push("/videos");
    },
  },
};
</script>

<style></style>
